import type { PatternMetadata } from '@takeshape/schema';
import type { handleSuccessPayload } from 'app/common/saga';
import { createRoutine } from 'app/common/utils/new-routines';
import { type ActionType, createAction } from 'typesafe-actions';
import type { IMPORT_STATUS } from '../common/types.js';
import type {
  GetProjectImportParams,
  GetProjectImportResponse,
  ImportProjectMutationParams,
  ImportProjectMutationResponse
} from './api';

export type Action =
  | ActionType<typeof fetchPatternMetadata>
  | ActionType<typeof setError>
  | ActionType<typeof setImportStatus>
  | ActionType<typeof setRepo>
  | ActionType<typeof importComplete>;

export const fetchPatternMetadata = createRoutine('add-to-takeshape/FETCH_PATTERN_METADATA')<
  undefined,
  string,
  undefined,
  { patternMetadata: PatternMetadata },
  string,
  undefined
>();

export const projectImportRoutine = createRoutine('add-to-takeshape/PROJECT_IMPORT')<
  undefined,
  { params: ImportProjectMutationParams },
  undefined,
  { response: ImportProjectMutationResponse },
  string,
  undefined
>();

export const importStatusRoutine = createRoutine('add-to-takeshape/IMPORT_STATUS')<
  undefined,
  { params: GetProjectImportParams },
  undefined,
  { response: GetProjectImportResponse },
  string,
  undefined
>();

export const setError = createAction('add-to-takeshape/SET_ERROR')<string>();
export const setImportStatus = createAction('add-to-takeshape/SET_IMPORT_STATUS')<IMPORT_STATUS>();
export const setRepo = createAction('add-to-takeshape/SET_REPO')<string | null>();
export const importComplete = createAction('add-to-takeshape/IMPORT_COMPLETE')<handleSuccessPayload>();
